export default __webpack_public_path__ + "static/media/lobby_14oct.a21cec06.jpg";